import ptzControl from './ptz-control'

const install = function (Vue) {
    Vue.directive('ptz-control', ptzControl)
}

if (window.Vue) {
    window['ptz-control'] = ptzControl
    Vue.use(install); // eslint-disable-line
}

ptzControl.install = install
export default ptzControl
